export class ApplicationPayment {
    ApplicationNumber: string;
    InvoiceNumber: string;
    ApplicationFee: number;
    Currency: string;
    VoucherNumber: string;
    DiscountAmount: number;
    TotalAmountAfterDiscount: number;
}


export class Voucher {
    VoucherId: number;
    VoucherNumber: string;
    IsValid: boolean;
    VoucherDiscountAmount: number;
    TotalAmountAfterDiscount: number;
    IsFullDiscount: boolean;
}


export class PaymentUpdateModel {

  ApplicationId: number;
  ResponseCode: string;
  ReceiptNumber: string;
  PaymentStatus: string;
}

export class CohortPaymentParameter {

  //#region Common Shared

  // Application ID of the web application (load corresponding settings from ApplicationDetail.xml)
  ApplicationTypeId: number;
  ApplicationId: number;
  InvoiceNumber: string;
  PaymentDescription: string;
  PaymentAmount:number

//#endregion


//#region Cohort part
  Partner: string;
  CancelUrl: string;
  CompletionUrl: string;
  FingerPrint: string; //a fingerprint calculated as hex(sha1(timestamp '|' secret '|' invoice '|' amount)) (where amount is formatted as XXX.XX)
  DocumentUrl: string;
  Locale: string;
  TimeStamp: string;
  Email: string;
  GivenName: string;
  FamilyName: string;
  DOB: string;
  Phone1: string;
  HomeCountry: string;
  PassportCountry: string;
  PassportNumber: string;

//#endregion
}
